/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import { Button, TooltipWrapper } from '@zapier/design-system';
import { responsiveStylesFn } from '@zapier/responsive-utils';

import { useSize } from '@zapier/checkout/src/hooks';

const wrapperStyles = responsiveStylesFn({
  small: css`
    display: flex;
    flex-direction: column;
  `,
  medium: css`
    flex-direction: row-reverse;
  `,
});

type ChangePlanButtonsProps = {
  isDisabled: boolean;
  onCancelChangePlan: () => void;
  onChangePlan: () => void;
  popoverText: string | null | undefined;
  submitText: string;
};

export const ChangePlanButtons = ({
  isDisabled,
  onCancelChangePlan,
  onChangePlan,
  popoverText,
  submitText,
}: ChangePlanButtonsProps) => {
  const size = useSize();

  return (
    <div css={wrapperStyles(size)}>
      <TooltipWrapper content={popoverText}>
        {({ childProps }) => (
          <Button
            {...childProps}
            color="primary"
            disabled={isDisabled}
            isFullWidth={true}
            onClick={onChangePlan}
          >
            {submitText}
          </Button>
        )}
      </TooltipWrapper>

      <Button color="tertiary" onClick={onCancelChangePlan}>
        Cancel
      </Button>
    </div>
  );
};
